/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type ViewInRoomImage_user = {
    readonly " $fragmentRefs": FragmentRefs<"useItemDisplayDimensions_user">;
    readonly " $refType": "ViewInRoomImage_user";
};
export type ViewInRoomImage_user$data = ViewInRoomImage_user;
export type ViewInRoomImage_user$key = {
    readonly " $data"?: ViewInRoomImage_user$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ViewInRoomImage_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ViewInRoomImage_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useItemDisplayDimensions_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '351b95c399923fa03648a92b56a10101';
export default node;
